export default __webpack_public_path__ + "98e4f292db72a09d18e1477772321b99.png";